// #ux-redesign-start: Card primitive (Paso 2)
// Superficie única, sin anidamiento. Reemplaza el `Card>CardBody>Card>CardHeader+CardBody`
// que hoy aparece como wrapper en ~80% de las vistas.
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <Card>{content}</Card>
//   <Card padding="lg" border>{content}</Card>
//   <Card elevation={1} interactive onClick={...}>{content}</Card>
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const Card = React.forwardRef(({
  padding = 'md',
  elevation = 0,
  border = true,
  interactive = false,
  as: Tag = 'div',
  className = '',
  children,
  ...rest
}, ref) => {
  const classes = [
    'ds-card',
    `ds-card--padding-${padding}`,
    `ds-card--elevation-${elevation}`,
    border ? 'ds-card--bordered' : '',
    interactive ? 'ds-card--interactive' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
});

Card.displayName = 'Card';

Card.propTypes = {
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  elevation: PropTypes.oneOf([0, 1, 2, 3, 4]),
  border: PropTypes.bool,
  interactive: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Card;
// #ux-redesign-end
